import React, { useState, useEffect } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../components/Loader'
import Message from '../../components/Message'
import { login } from '../../actions/userActions'
import { USER_LOGIN_RESET } from '../../constants/userConstants'

function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  const [isFromMobilePricing, setIsFromMobilePricing] = useState(false);

  const userLogin = useSelector(state => state.userLogin)
  const { error, loading, userInfo } = userLogin

  useEffect(() => {
    dispatch({ type: USER_LOGIN_RESET })

    // Sprawdź czy przychodzi z aplikacji mobilnej
    const params = new URLSearchParams(location.search)
    const fromParam = params.get('from')
    if (fromParam === 'mobile' || fromParam === 'mobile_pricing') {
      setIsFromMobilePricing(true)
    }
  }, [dispatch, location.search])

  useEffect(() => {
      if (userInfo) {
        // Jeśli użytkownik przyszedł z aplikacji mobilnej, przekieruj na pricing
        if (isFromMobilePricing) {
          navigate('/pricing')
        } else {
          // Dynamiczny redirect na podstawie user_type
          let redirect;
          if (userInfo.user_type === 'employer') {
            redirect = '/employer-home';
          } else if (userInfo.user_type === 'adult_worker') {
            redirect = '/link-requests';
          } else {
            redirect = '/home-screen';
          }
          navigate(redirect)
        }
      }
    }, [navigate, userInfo, isFromMobilePricing])

  const submitHandler = (e) => {
    e.preventDefault()
    dispatch(login(email, password))
  }

  return (
    <div className="pub-form-box">
      <h1 className="pub-h2">{isFromMobilePricing ? 'Zaloguj się do SIGMY' : 'Zaloguj się'}</h1>
      <p className="pub-muted" style={{ marginBottom: 28 }}>
        {isFromMobilePricing
          ? 'Użyj tych samych danych co w aplikacji mobilnej, żeby zobaczyć plany subskrypcji.'
          : 'Witaj ponownie. Wpisz adres e-mail i hasło.'}
      </p>

      <div className="pub-card">
        {error && <Message variant='danger'>{error}</Message>}
        {loading && <Loader />}

        <Form onSubmit={submitHandler}>
          <Form.Group className="mb-3" controlId="login-email">
            <Form.Label>Adres e-mail</Form.Label>
            <Form.Control
              type='email'
              placeholder='twoj.email@example.com'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-2" controlId="login-password">
            <Form.Label>Hasło</Form.Label>
            <Form.Control
              type='password'
              placeholder='Wpisz hasło'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </Form.Group>

          <div className="text-end mb-4">
            <Link to="/forgot-password" className="pub-link" style={{ fontSize: 15 }}>Nie pamiętasz hasła?</Link>
          </div>

          <button type="submit" className="pub-btn w-100">Zaloguj się</button>
        </Form>
      </div>

      <p className="pub-muted" style={{ marginTop: 24 }}>
        Nie masz konta?{' '}
        <Link to="/register?type=employer" className="pub-link">Załóż konto firmy</Link>
        {' '}albo{' '}
        <Link to="/register?type=adult_worker" className="pub-link">konto pracownika</Link>.
      </p>
    </div>
  )
}

export default Login
